<template>
  <div
    v-if="visible"
    class="fixed top-0 left-0 right-0 z-50 h-0.5 overflow-hidden"
  >
    <div class="absolute inset-0 bg-primary-500 opacity-30" />
    <div class="absolute inset-y-0 animate-loading-bar bg-primary-500" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  visible: boolean
}>()
</script>

<style scoped>
@keyframes loading-bar-slide {
  0% {
    left: -40%;
    right: 100%;
  }
  40% {
    left: -20%;
    right: 20%;
  }
  100% {
    left: 100%;
    right: -40%;
  }
}

.animate-loading-bar {
  animation: loading-bar-slide 1.6s ease-in-out infinite;
}
</style>
